import { fulfillmentApi } from '../../../api/fulfillmentApi';
import { IEntityToDisable } from '../../../models/entityToDisable';
import { createGroup, IGroup } from '../../../models/groups';
import { AppDispatch, RootState } from '../../store';
import { setGroup, setGroups, startLoadingGroups, updateGroups } from './groupsSlice';

export const getGroups = (idParent?: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingGroups());

        let groups = {};
        if (idParent) {
            const resp = await fulfillmentApi.get(`groupsPerSubActivity/${idParent}`);
            groups = resp.data;
        }
        else {
            const resp = await fulfillmentApi.get(`groups`);
            groups = resp.data;
        }

        dispatch(setGroups({ groups }));
    }
}

export const getGroup = (groupId: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingGroups());
        const resp = await fulfillmentApi.get(`groups/${groupId}`);

        dispatch(setGroup({ group: resp.data }));
    }
}

export const saveGroup = (group: IGroup) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingGroups());
        const newGroup = createGroup(group);
        const resp = await fulfillmentApi.post(`groups`, newGroup);

        const state = getState();
        let groups = [...state.groups.groups];
        groups.push(resp.data);

        dispatch(setGroups({ groups }));
    }
}

export const editGroup = (group: IGroup) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingGroups());
        await fulfillmentApi.put(`groups/${group.id}`, group);

        const resp = await fulfillmentApi.get(`groups/${group.id}`);

        dispatch(setGroup({ group: resp.data }));
        dispatch(updateGroups({ group: resp.data }));
    }
}

export const disableGroup = (entityToDisable: IEntityToDisable) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingGroups());

        await fulfillmentApi.put(`groups/expire/${entityToDisable.id}`, entityToDisable);

        const resp = await fulfillmentApi.get(`groups/${entityToDisable.id}`);

        dispatch(setGroup({ group: resp.data }));
        dispatch(updateGroups({ group: resp.data }));
    }
}

export const addGroup = (groupId: number, idParent: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingGroups());

        let groups = {};

        await fulfillmentApi.post(`groupsPerSubActivity/${idParent}?groupId=${groupId}`);
        let r = await fulfillmentApi.get(`groupsPerSubActivity/${idParent}`);
        groups = r.data;

        dispatch(setGroups({ groups }));
    }
}

export const removeGroup = (groupId: number, idParent: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingGroups());

        let groups = {};

        await fulfillmentApi.delete(`groupsPerSubActivity/${idParent}?groupId=${groupId}`);
        let r = await fulfillmentApi.get(`groupsPerSubActivity/${idParent}`);
        groups = r.data;

        dispatch(setGroups({ groups }));
    }
}